import {Splide} from "@splidejs/splide";
import {next} from "lodash/seq";

const imageSlider = {
    init() {
        const arrowPath = 'M26.0298 19.4703C26.3204 19.7609 26.3204 20.239 26.0298 20.5297L17.0298 29.5297C16.7392 29.8203 16.261 29.8203 15.9704 29.5297C15.6798 29.239 15.6798 28.7609 15.9704 28.4703L24.4407 20L15.9704 11.5297C15.6798 11.239 15.6798 10.7609 15.9704 10.4703C16.261 10.1797 16.7392 10.1797 17.0298 10.4703L26.0298 19.4703Z';

        if (document.getElementById('simple-image-slider')) {
            var imageCarousel = new Splide( '#simple-image-slider', {
                type      : 'fade',
                rewind    : true,
                pagination: true,
                arrows    : true,
                arrowPath: arrowPath,
                speed: 1500,
            });
            imageCarousel.mount();
        }

        if (document.getElementById('image-thumbnail-slider')) {

            // Collects LI elements:
            let allThumbnails = document.getElementsByClassName('image-slider-thumbnail');

            var thumbnails = new Splide( '#image-thumbnail-slider', {
                direction: 'ttb',
                height: 500,
                gap       : 16,
                rewind    : false,
                pagination: false,
                focus      : 'center',
                isNavigation: true,
                arrows    : true,
                arrowPath: arrowPath,
                perPage: allThumbnails.length > 3 ? 3.5 : 3,
                speed: 800,
                updateOnMove: true,
                breakpoints: {
                    1024: {
                        height: 300,
                    }
                }
            });

            var main = new Splide( '#thumbnail-slider-main', {
                type      : 'fade',
                rewind    : true,
                pagination: true,
                arrows    : false,
                speed: 800,
            });
            main.on('resize', () => {
                let mainSlider = document.querySelector('#thumbnail-slider-main .splide__track');
                if (mainSlider) {
                    thumbnails.options.height = mainSlider.clientHeight;
                }
            });


            main.sync(thumbnails);
            main.mount();
            thumbnails.mount();

            let nextArrow = document.querySelector('#image-thumbnail-slider .splide__arrow--next');
            let prevArrow = document.querySelector('#image-thumbnail-slider .splide__arrow--prev');
            nextArrow.addEventListener('mouseover', () => {
                this.mouseOver(prevArrow, nextArrow);
            });
            prevArrow.addEventListener('mouseover', () => {
                this.mouseOver(prevArrow, nextArrow);
            });
            prevArrow.addEventListener('mouseout', () => {
                this.mouseOut(prevArrow, nextArrow)
            });
            nextArrow.addEventListener('mouseout', () => {
                this.mouseOut(prevArrow, nextArrow)
            });
            let splideTrack = document.querySelector('#image-thumbnail-slider .splide__track');
            splideTrack.addEventListener('mouseout', () => {
                this.mouseOut(prevArrow, nextArrow)
            });
        }
    },
    mouseOut(prevArrow, nextArrow) {
        nextArrow.style.visibility = 'none';
        prevArrow.style.visibility = 'none';
    },
    mouseOver(prevArrow, nextArrow) {
        nextArrow.style.visibility = 'visible';
        prevArrow.style.visibility = 'visible';
    }
};

export { imageSlider as default };
